document.addEventListener("DOMContentLoaded", function() {
  // Set the current menu item
  var currentPath = window.location.pathname;
  var regexMatch;
  
  // Adjust for blog and shopping pages
  var blogRegex = new RegExp('\/blogs\/[^\/]*');
  var shopRegex1 = new RegExp('\/collections\/(?!sale).*');
  var shopRegex2 = new RegExp('\/products.*');
  
  if ((regexMatch = blogRegex.exec(currentPath)) !== null) {
    currentPath = regexMatch[0];
  } else if (
    (regexMatch = shopRegex1.exec(currentPath)) !== null ||
    (regexMatch = shopRegex2.exec(currentPath)) !== null
     ) {
    currentPath = '/collections/shop-all';
  }

  var currentLinkSelector = (currentPath.length > 1)
    ? 'nav a[href="' + currentPath + '"]'
    : 'nav a[href="/"]';
  document.querySelectorAll(currentLinkSelector).forEach(function(link) {
    var navItem = link.closest('.nav-item');
    if (!navItem) return;
    navItem.classList.add('current');
  });

});
